import React from "react";
//import PropTypes from 'prop-types';

export function Filters(props) {
    const {} = props;
    return <div>Filters</div>;
}

Filters.propTypes = {};

Filters.defaultProps = {};

export default Filters;
